import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

interface CompanyCodeprops {
  params: CompanyCodeListReqDto;
}

const useCompanyCode = ({params}: CompanyCodeprops) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [codeList, setCodeList] = useState<CompanyCodeListDto[]>();

  const { isLoading, refetch } = useQuery(
    [endpoints.company.code, params],
    () =>
      fetcher.company.postCompanyCodeList(params),
    {
      enabled: (!!params.searchValue &&  params.searchValue != '') || (!!params.company && params.company > 0),      
      onSuccess: (res: CompanyCodeListResDto) => {
        switch (res.code) {
          case 200:
            setCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, codeList, refetch  };
};

export default useCompanyCode;
